import { axiosWithoutAuth, axiosAuth } from "./axiosInstances";
//agregar una funcion por cada endpoint necesario, asegurarse de usar el async-await, ya que son peticiones a la api

// KHAN-254: api/join/ -> api/invitations/ (DefaultRouter + InvitationViewSet,
// lookup_field="code"). checkJoin/ -> POST invitations/{code}/redeem/
// (domain action; code now goes in the URL, same as searchCode below).
// search/{code}/ -> GET invitations/{code}/. new-join/ -> POST invitations/.
export async function checkJoin(code, password) {
    return axiosWithoutAuth().post("invitations/"+encodeURIComponent(code)+"/redeem/",{
        password:password
    })
}

export async function searchCode(code){
   return axiosWithoutAuth().get("invitations/"+encodeURIComponent(code)+"/")
}

export async function new_join (bookid,classesid) {
    return axiosAuth().post("invitations/",{
        bookid:String(bookid),
        classesid:String(classesid)
    })
}